import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import { initializeGoogleAnalytics } from "./services/googleAnalytics";
import "./styles/tailwind.css";
import "./styles/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");
const root = createRoot(container);

void initializeGoogleAnalytics();

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
